import React from "react";
import styles from "./style.module.scss";
import {Footer, Header} from "@components";

export default function Component({children}: {children: React.ReactNode}) {
  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.content}>{children}</div>
      <Footer />
    </div>
  );
}
